const CHANGE_LOGGED_IN = 'CHANGE_LOGGED_IN';

const changeLoginAction = (isLoggedIn) => (dispatch) => {
    dispatch({
        type: CHANGE_LOGGED_IN,
        viewtype: { isLoggedIn }
    });
};

export default changeLoginAction;
